import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/nafath/check.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var checkNafath = (props) => __async(null, null, function* () {
  try {
    const lang = getLocaleOnly(props.locale);
    const data = yield fetchClient({
      url: "/nafath/check-status",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, props), { lang }))
      }
    });
    if (data.status === "WAITING") {
      return;
    }
    if (data.status !== "COMPLETED" || data.error) {
      const msg = data.error;
      throw new Error(msg || "Somthing went wrong");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "checkNafathException",
      context: { extra: props }
    });
  }
});

export {
  checkNafath
};
//# sourceMappingURL=chunk-447J5VLV.mjs.map